import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";

import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import Select from "react-select";
import {BiSolidSelectMultiple} from "react-icons/bi";
import EmptyPic from "../../Assets/Images/nophoto.png";
import {LiaUserEditSolid} from "react-icons/lia";


const currencyFormat = Intl.NumberFormat('en-US');


function InsertProduct() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [ , setGroups] = React.useState([]);
    const [name, setName] = React.useState('');
    const [brief, setBrief] = React.useState('');
    const [description, setDescription] = React.useState('');

    const [inboxCount, setInboxCount] = React.useState(0);
    const [price, setPrice] = React.useState(0);
    const [eachPrice, setEachPrice] = React.useState(0);
    const [discountPercent, setDiscountPercent] = React.useState(0);
    const [consumerPrice, setConsumerPrice] = React.useState(0);
    const [wholesaleAmount, setWholesaleAmount] = React.useState(-1);
    const [wholesalePercent, setWholesalePercent] = React.useState(0);
    const [taxPercent, setTaxPercent] = React.useState(0);
    const [unitId, setUnitId] = React.useState(0);
    const [countUnits, setCountUnits] = React.useState([]);
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedOptions, setSelectedOptions] = React.useState();
    const [photo, ] = React.useState(null);
    const [filePhoto, setFilePhoto] = React.useState(null);
    const [picPhoto, setPicPhoto] = React.useState(EmptyPic);
    const [unit, setUnit] = React.useState('عددی');

    const [suggestions, setSuggestions] = React.useState([]);
    const [showSuggestions, setShowSuggestions] = React.useState(false);
    const [suggestLoading, setSuggestLoading] = React.useState(false);
    const skipSearchRef = React.useRef(false);   // برای جلوگیری از جستجو بعد از انتخاب
    const requestIdRef = React.useRef(0);        // برای نادیده گرفتن پاسخ‌های قدیمی
    const suggestBoxRef = React.useRef(null);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        API.getUserInfo()
            .then((response) => {
                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


        API.getCountUnit()
            .then((response) => {
                setCountUnits(response.data.count_units);

            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

        const params = {
            count: 2000,
            for_suppliers: 1
        }

        API.getProductGroups(params)
            .then((response) => {
                setGroups(response.data);
                const groups = response.data;
                let options = [];
                for(let data in groups) {

                    options.push({
                        value : groups[data].id,
                        label : groups[data].name,
                    })
                }
                setSelectOptions(options)
                setIsLoaded(true);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


    }, []);


    React.useEffect(() => {
        if (skipSearchRef.current) {
            skipSearchRef.current = false;
            return;
        }

        const term = name.trim();
        if (term.length < 3) {
            requestIdRef.current++;
            setSuggestions([]);
            setShowSuggestions(false);
            setSuggestLoading(false);
            return;
        }

        const timer = setTimeout(() => {
            const myId = ++requestIdRef.current;
            setSuggestLoading(true);

            API.searchProducts({search: term})
                .then((response) => {
                    if (myId !== requestIdRef.current) return; // پاسخ قدیمی
                    const list = Array.isArray(response.data) ? response.data : [];

                    // حذف نام‌های تکراری
                    const seen = new Set();
                    const unique = list.filter((p) => {
                        if (!p?.name || seen.has(p.name)) return false;
                        seen.add(p.name);
                        return true;
                    });

                    setSuggestions(unique.slice(0, 10));
                    setShowSuggestions(unique.length > 0);
                    setSuggestLoading(false);
                })
                .catch(() => {
                    if (myId !== requestIdRef.current) return;
                    setSuggestLoading(false);
                    setSuggestions([]);
                    setShowSuggestions(false);
                });
        }, 300);

        return () => clearTimeout(timer);
    }, [name]);

// بستن لیست با کلیک بیرون
    React.useEffect(() => {
        const handleClickOutside = (e) => {
            if (suggestBoxRef.current && !suggestBoxRef.current.contains(e.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const onSelectSuggestion = (value) => {
        skipSearchRef.current = true;
        setName(value);
        setSuggestions([]);
        setShowSuggestions(false);
    };

    const onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            setPicPhoto(reader.result);
            setFilePhoto(event.target.files[0])
        };
    }

    const onClickSaveButton = () => {
        setIsLoaded(false);



        const formData = new FormData();
        if (filePhoto)
            formData.append('photo', filePhoto);

        formData.append('name', name);
        formData.append('description', description);
        formData.append('brief', brief);
        formData.append('price', price);
        formData.append('each_price', eachPrice);
        formData.append('in_box_count', inboxCount);
        formData.append('tax_percent', taxPercent);
        formData.append('group_id', selectedOptions?.value);
        formData.append('counting_unit_id', unitId);
        formData.append('unit', unit);
        formData.append('consumer_price', consumerPrice);
        formData.append('wholesale_percent', wholesalePercent);
        formData.append('discount_percent', discountPercent);
        formData.append('wholesale_amount', wholesaleAmount);
        formData.append('vendor_id', window.localStorage.getItem("vendor"));

        API.insertProduct(formData)
            .then((response) => {
                toast.success(response.message);
                setIsLoaded(true);
                setTimeout(() => {
                    window.location.replace(`/products`);
                }, 1500)
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>
                                     <div className="col-12 item "
                                         onClick={() => navigate(`/home`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                         id='active'
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}

                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5 product-form main-part mt-md-5">
                        <div className="row">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                                ثبت کالا
                            </div>
                            <div className="col-12 ">

                                <img alt="Pic"
                                     src={(photo && !filePhoto) ? photo : picPhoto}
                                     width={85} className='rounded'/>
                                <span className="px-5">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر کالا
                                                 <input type="file" onChange={onFileChange}/>
                                                </label>
                                            </span>
                            </div>
                            <div className="col-md-12" ref={suggestBoxRef} style={{position: 'relative'}}>

                                <label htmlFor="floatingInput">
                                    نام کالا
                                </label>

                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"
                                           autoComplete="off"
                                           value={name}
                                           onChange={(event) => setName(event.target.value)}
                                           onFocus={() => {
                                               if (suggestions.length > 0) setShowSuggestions(true);
                                           }}
                                           onKeyDown={(e) => {
                                               if (e.key === 'Escape') setShowSuggestions(false);
                                           }}
                                    />

                                    {suggestLoading && (
                                        <div className="text-muted small text-center mt-1">
                                            در حال جستجو...
                                        </div>
                                    )}

                                    {showSuggestions && suggestions.length > 0 && (
                                        <ul className="list-group shadow"
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                right: 0,
                                                left: 0,
                                                zIndex: 1050,
                                                maxHeight: 260,
                                                overflowY: 'auto',
                                                margin: 0,
                                                padding: 0
                                            }}>
                                            <li className="list-group-item bg-light small text-muted">
                                                کالاهای مشابه موجود (برای انتخاب کلیک کنید)
                                            </li>
                                            {suggestions.map((p) => (
                                                <li key={p.id ?? p.name}
                                                    className="list-group-item list-group-item-action text-center"
                                                    style={{cursor: 'pointer'}}
                                                    onMouseDown={(e) => {
                                                        e.preventDefault(); // جلوگیری از blur شدن input
                                                        onSelectSuggestion(p.name);
                                                    }}>
                                                    {p.name}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            {/*           <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    توضیحات مختصر
                                </label>
                                <div className="form-floating mb-3">
                                    <textarea
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={brief}
                                        onChange={
                                            (event) => {
                                                setBrief(event.target.value)
                                            }
                                        }
                                    >
                                    </textarea>

                                </div>
                            </div>*/}
                            <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    انتخاب گروه کالا
                                </label>

                                <div className="form-floating mb-3">
                                    <Select
                                        options={selectOptions}
                                        placeholder="گروه کالا"
                                        value={selectedOptions}
                                        isSearchable={true}
                                        onChange={
                                            (event) => {
                                                setSelectedOptions(event)
                                            }
                                        }
                                    />


                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    انتخاب واحد شمارش کالا
                                </label>
                                <div className="form-floating mb-3">
                                    <select
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={unitId}
                                        onChange={
                                            (event) => {
                                                setUnitId(event.target.value)
                                            }
                                        }
                                    >
                                        <option value="0">
                                            انتخاب واحد شمارش
                                        </option>
                                        {
                                            isLoaded && countUnits.map(unit => {
                                                return (
                                                    <option value={unit.id} key={unit.id}>
                                                        {unit.title}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>

                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    تعداد در بسته
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={inboxCount}
                                           onChange={
                                               (event) => {
                                                   setInboxCount(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    عنوان واحد کالا
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={unit}
                                           onChange={
                                               (event) => {
                                                   setUnit(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="floatingInput">
                                    توضیحات
                                </label>
                                <div className="form-floating mb-3">
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                        }}
                                    />


                                </div>
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    قیمت مصرف کننده
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={consumerPrice}
                                           onChange={
                                               (event) => {
                                                   setConsumerPrice(event.target.value)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(consumerPrice / 10))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    قیمت هر عدد (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={eachPrice}
                                           onChange={
                                               (event) => {
                                                   setEachPrice(event.target.value)
                                                   setPrice(event.target.value * inboxCount)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(eachPrice / 10))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    قیمت پایه (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={price}
                                           onChange={
                                               (event) => {
                                                   setEachPrice(Math.round(event.target.value / inboxCount))

                                                   setPrice(event.target.value)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(price / 10))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    درصد تخفیف پایه
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={discountPercent}
                                           onChange={
                                               (event) => {
                                                   setDiscountPercent(event.target.value)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(price * (100 - discountPercent) / 1000))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>
                           {/* <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    درصد مالیات
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={taxPercent}
                                           onChange={
                                               (event) => {
                                                   setTaxPercent(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>*/}

                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    حد آستانه تخفیف حجمی
                                </label>
                                <div className="form-floating ">
                                    <input type="number"
                                           className="form-control text-center text-small-1 ltr"
                                           id="floatingInput"

                                           value={wholesaleAmount}
                                           onChange={
                                               (event) => {
                                                   setWholesaleAmount(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                                <p className='text-small-3 text-center text-secondary opacity-50 mt-0 ltr'>
                                    برای عدم محاسبه 1- وارد کنید
                                </p>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="floatingInput">
                                    درصد تخفیف خرید حجمی
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={wholesalePercent}
                                           onChange={
                                               (event) => {
                                                   setWholesalePercent(event.target.value)
                                               }
                                           }
                                    />

                                    <div className='price-hint'>
                                        {currencyFormat.format(Math.round(price * (100 - wholesalePercent) / 1000))}
                                        &nbsp;
                                        تومان
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 mt-3">
                                &nbsp;
                            </div>
                            <div className="col-md-6 mt-3">


                                <button className='btn btn-success w-100'
                                        onClick={onClickSaveButton}
                                        disabled={!isLoaded}
                                >
                                    ثبت اطلاعات
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default InsertProduct;